import axios from 'axios';
import { set } from 'lodash';
import { enqueueSnackbar } from 'notistack';
import { createTask, deleteTask } from 'src/api/kanbanModifyByValdo';
import axiosInstance, { endpoints } from 'src/utils/axios';

let uploadProgress;
let uploadProgressContributor;
let uploadProgressTraineeAdd;
let uploadProgressTraineeProfil;

let loadIsCanceled = false;
let loadContributorAddIsCanceled = false;
let loadTraineeAddIsCanceled = false;
let loadTraineeProfilIsCanceled = false;

let loadIsCompleted = false;
let loadContributorAddIsCompleted = false;
let loadTraineeAddIsCompleted = false;
let loadTraineeProfilIsCompleted = false;

let uplaodImgStart = false;
let ContributorAdduplaodImgStart = false;
let TraineeAdduplaodImgStart = false;
let TraineeProfiluplaodImgStart = false;

export const setUploadProgress = (pathCall, progress) => {
  if (pathCall === 'contributorAdd') {
    uploadProgressContributor = progress;
    // uploadProgress = null
    if (progress === 100) {
      // console.log('add add add');

      uploadProgressContributor = 101;
      loadContributorAddIsCompleted = true;
    }
  }

  if (pathCall === 'contributorprofil') {
    uploadProgress = progress;
    // uploadProgressContributor = null
    if (progress === 100) {
      // console.log('profil profil profil');
      uploadProgress = 101;
      loadIsCompleted = true;
    }
  }

  if (pathCall === 'traineeAdd') {
    uploadProgressTraineeAdd = progress;
    // uploadProgressContributor = null
    if (progress === 100) {
      // console.log('profil profil profil');
      uploadProgressTraineeAdd = 101;
      loadTraineeAddIsCompleted = true;
    }
  }

  if (pathCall === 'traineeprofil') {
    uploadProgressTraineeProfil = progress;
    // uploadProgressContributor = null
    if (progress === 100) {
      // console.log('profil profil profil');
      uploadProgressTraineeProfil = 101;
      loadTraineeProfilIsCompleted = true;
    }
  }
};

export const getUploadProgress = () => uploadProgress;
export const getUploadProgressAddContributor = () => uploadProgressContributor;
export const getUploadProgressAddTrainee = () => uploadProgressTraineeAdd;
export const getUploadProgressProfilTrainee = () => uploadProgressTraineeProfil;

export const loadIsCancel = () => loadIsCanceled;
export const loadContributorAddIsCancel = () => loadContributorAddIsCanceled;
export const loadTraineeAddIsCancel = () => loadTraineeAddIsCanceled;
export const loadTraineeProfilIsCancel = () => loadTraineeProfilIsCanceled;

export const loadIsComplete = () => loadIsCompleted;
export const loadContributorAddIsComplete = () => loadContributorAddIsCompleted;
export const loadTraineeAddIsComplete = () => loadTraineeAddIsCompleted;
export const loadTraineeProfilIsComplete = () => loadTraineeProfilIsCompleted;

export const resetLoadIsComplete = () => {
  uploadProgressTraineeProfil = 0;
  uploadProgressTraineeAdd = 0;
  uploadProgressContributor = 0;
  uploadProgress = 0;

  loadIsCompleted = false;
  loadContributorAddIsCompleted = false;
  loadTraineeAddIsCompleted = false;
  loadTraineeProfilIsCompleted = false;

  loadIsCanceled = false;
  loadContributorAddIsCanceled = false;
  loadTraineeAddIsCanceled = false;
  loadTraineeProfilIsCanceled = false;
};
export const setuploadImgStart = (valGet) => {
  uplaodImgStart = valGet;
};
export const setContributorAdduplaodImgStart = (valGet) => {
  ContributorAdduplaodImgStart = valGet;
};
export const setTraineeAdduplaodImgStart = (valGet) => {
  TraineeAdduplaodImgStart = valGet;
};
export const setTraineeProfiluplaodImgStart = (valGet) => {
  TraineeProfiluplaodImgStart = valGet;
};

export const getuploadImgStart = () => uplaodImgStart;
export const getContributorAdduplaodImgStart = () => ContributorAdduplaodImgStart;
export const getTraineeAdduplaodImgStart = () => TraineeAdduplaodImgStart;
export const getTraineeProfiluplaodImgStart = () => TraineeProfiluplaodImgStart;

// Fonction pour gérer l'annulation

export async function uploadImage(imageObject, cancelToken, pathCall) {
  try {
    // console.log('appelr');

    // Crée un objet FormData
    loadIsCanceled = false;
    loadContributorAddIsCanceled = false;
    loadTraineeAddIsCanceled = false;
    loadTraineeProfilIsCanceled = false;

    uplaodImgStart = true;
    ContributorAdduplaodImgStart = true;
    TraineeAdduplaodImgStart = true;
    TraineeProfiluplaodImgStart = true;

    const formData = new FormData();
    formData.append('image', imageObject); // Ajoute l'image au FormData

    // Envoie la requête avec FormData et gestion de la progression
    const response = await axiosInstance.post(endpoints.user.uploadImage, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: (progressEvent) => {
        const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);

        if (pathCall === 'contributorAdd') {
          setUploadProgress('contributorAdd', progress);

          // console.log("progression de l'upload de l'inage contributor  get", getUploadProgressAddContributor());
        }

        if (pathCall === 'contributorprofil') {
          setUploadProgress('contributorprofil', progress);

          // console.log("progression de l'upload de l'inage profil call", progress);
        }

        if (pathCall === 'traineeAdd') {
          setUploadProgress('traineeAdd', progress);

          // console.log("progression de l'upload de l'inage traineeAdd", progress);
        }

        if (pathCall === 'traineeprofil') {
          setUploadProgress('traineeprofil', progress);

          // console.log("progression de l'upload de l'inage traineeprofil traineeprofil", progress);
        }
      },

      cancelToken,
    });

    return response.data;
  } catch (error) {
    if (axios.isCancel(error)) {
      // console.log('Upload annulé', error.message);
      loadIsCanceled = true;
      loadContributorAddIsCanceled = true;
      loadTraineeAddIsCanceled = true;
      loadTraineeProfilIsCanceled = true;
    } else {
      // console.log(error);
      loadIsCanceled = true;
      loadContributorAddIsCanceled = true;
      loadTraineeAddIsCanceled = true;
      loadTraineeProfilIsCanceled = true;

      throw error;
    }
    return null; // ou une autre valeur par défaut
  }
}

export async function addFormation(formationData) {
  try {
    const response = await axiosInstance.post(endpoints.formations.add, { ...formationData });
    // console.log('donner recuperer apres ajout de la nouvelle formation', response.data);

    addNewFormationLocal(formationData, response.data.sessionID);
    return response.data; // Retourne les données si la requête réussit
  } catch (error) {
    // console.error("Erreur lors de l'ajout de la formation :", error);
    return error;
  }
}

export async function deleteFormations(dataGet) {
  try {
    const response = await axiosInstance.post(endpoints.formations.delete, { ...dataGet.objectForRequet });
    // console.log('Réponse de la requête :', response.data);

    if (typeof dataGet.deleteTask === 'function') {
      dataGet.deleteTask();
    } else {
      // console.error('Le paramètre callback doit être une fonction.');
    }
    return response.data;
  } catch (error) {
    // console.error('Erreur lors de la requête :', error);
    return error;
  }
}

const addNewFormationLocal = (data, sessionID) => {
  let columID;

  if (data.planning === 'pending') {
    columID = '1-column-e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1';
  } else if (data.planning === 'planned') {
    columID = '2-column-e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2';
  } else if (data.planning === 'ended') {
    columID = '3-column-e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3';
  }
  const defautKanbanObject = {
    // "id": String( formation.session_id ),
    id: String(sessionID),
    session_id: String(sessionID),
    due: [null, null],
    status: data.planning,
    labels: [],
    comments: [],
    assignee: [
      {
        id: 'e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1',
        name: 'Jayvion Simon',
        avatarUrl: 'https://api-dev-minimal-v510.vercel.app/assets/images/avatar/avatar_1.jpg',
      },
      {
        id: 'e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2',
        name: 'Lucian Obrien',
        avatarUrl: 'https://api-dev-minimal-v510.vercel.app/assets/images/avatar/avatar_2.jpg',
      },
      {
        id: 'e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3',
        name: 'Deja Brady',
        avatarUrl: 'https://api-dev-minimal-v510.vercel.app/assets/images/avatar/avatar_3.jpg',
      },
    ],
    priority: 'low',
    attachments: [],
    trainees: [],
    reporter: {
      id: 'e99f09a7-dd88-49d5-b1c8-1daf80c2d7b17',
      name: 'Angelique Morse',
      avatarUrl: 'https://api-dev-minimal-v510.vercel.app/assets/images/avatar/avatar_17.jpg',
    },
    name: 'Complete Project Proposal',
    description: 'Occaecati est et illo quibusdam accusamus qui. Incidunt aut et molestiae ut facere aut. Est quidem iusto praesentium excepturi harum nihil tenetur facilis. Ut omnis voluptates nihil accusantium doloribus eaque debitis.',
  };

  const mergedFormation = { ...data, ...defautKanbanObject }; // Fusionne task avec additionalData

  // console.log("apple de la fonctin d'ajout local", mergedFormation);
  createTask(columID, mergedFormation);
};
